<template>
  <div class="menu_component">

      <div class="menu_column">
          <router-link :to="{ path:'/' }"><div class="menu_item">Početna</div></router-link>
          <router-link :to="{ path:'/page/street-food' }"><div class="menu_item">Street Food</div></router-link>
      </div>
      <div class="menu_column">
          <router-link :to="{ path:'/page/organizacija' }"><div class="menu_item">Organizacija</div></router-link>
          <router-link :to="{ path:'/eventi' }"><div class="menu_item">Eventi</div></router-link>
      </div>
      <div class="menu_column">
          <router-link :to="{ path:'/page/rental' }"><div class="menu_item">Rental</div></router-link>
          <!-- <router-link :to="{ path:'/page/kontakti' }"><div class="menu_item">Kontakti</div></router-link> -->
      </div>

  </div> <!-- menu component -->
</template>

<script>

export default {
  name: 'Menus'

}
</script>